import React, { useCallback } from 'react';
import { cx, PropTypes } from '~/utils';
import { useSpatialNav } from '~/hooks';
import { Button as ButtonRS } from 'reactstrap';

export function Button( props_in ) {
  const { shortcut, className, children, ...props } = props_in;
  const { onClick } = props;

  useSpatialNav( useCallback( ( key, ev, spatial ) => {
    if ( ! shortcut ) return false;
    if ( key !== shortcut ) return false;
    onClick();
    return true;
  }, [ shortcut, onClick ] ) );

  props.className = cx( 'focusable', className );
  return (
    <ButtonRS outline {...props}>
      { shortcut && ( <kbd className="mr-4">{shortcut}</kbd> ) }
      <span>{children}</span>
    </ButtonRS>
  );
}
Button.propTypes = {
  shortcut  : PropTypes.string,
  onClick   : PropTypes.func.isRequired,
};
